module.exports = __webpack_public_path__ + "static/media/ultrasound_technology.4df6e867.jpg";